export default __webpack_public_path__ + "locales/az/Webhooks.json?hash=09eea45798f8a0c8d699c3cd5b9f9d5c";